import { ValidationErrorBoundaryMode, ValidationErrorType, type DeepPartial } from "@ngt-form/core";
import type { MantineFormOptions } from "@ngt-form/mantine";
import { GroupedValidationErrorDisplayFormat } from "@ngt-form/mantine";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AppSettings from "./AppSettings";

const formIconCreator = (icon: IconDefinition) => () => <FontAwesomeIcon icon={icon} />;

const mantineFormOptions: DeepPartial<MantineFormOptions> = {
    icons: {
        delete: formIconCreator(AppSettings.icons.delete),
        validationError: {
            [ValidationErrorType.Description]: formIconCreator(AppSettings.icons.error.description),
            [ValidationErrorType.Information]: formIconCreator(AppSettings.icons.error.information),
            [ValidationErrorType.Warning]: formIconCreator(AppSettings.icons.error.warning),
            [ValidationErrorType.Low]: formIconCreator(AppSettings.icons.error.low),
            [ValidationErrorType.Medium]: formIconCreator(AppSettings.icons.error.medium),
            [ValidationErrorType.High]: formIconCreator(AppSettings.icons.error.high),
            [ValidationErrorType.Critical]: formIconCreator(AppSettings.icons.error.critical),
        },
    },
    fields: {
        groupedField: {
            validationErrorDisplayFormat: GroupedValidationErrorDisplayFormat.PopoverInput,
        },
        groupedTableField: {
            groupedField: {
                validationErrorBoundary: {
                    mode: ValidationErrorBoundaryMode.Contain,
                },
                validationErrorDisplayFormat: GroupedValidationErrorDisplayFormat.PopoverInput,
            },
        },
    },
};

export default mantineFormOptions;
